export default __webpack_public_path__ + "static/media/Water - Grey.fcd2720b.svg";